import { FC } from 'react';

import { useGetActiveBooking } from 'src/features/bookings';

import { useGetInspections } from '../hooks/use-get-inspections';
import { getInspectionStates } from '../utils/getInspectionStates';

import { NoUpcomingHousekeeping } from './housekeeping/no-upcoming-housekeeping';
import { InspectionState } from './enum/inspection-state';
import { UpcomingHousekeeping } from './housekeeping/upcoming-housekeeping';
import { RequestedHousekeeping } from './housekeeping/requested-housekeeping';
import { SkippedHousekeeping } from './housekeeping/skipped-housekeeping';
import { CancelledHousekeeping } from './housekeeping/cancelled-housekeeping';
import { ConfirmedHousekeeping } from './housekeeping/confirmed-housekeeping';
import { HousekeepingLoader } from './housekeeping/housekeeping-loader';
import { HousekeepingError } from './housekeeping/housekeeping-error';

interface Props {
    className?: string;
}

export const BuildingHouseKeeping: FC<Props> = ({ className }) => {
    const { data: booking } = useGetActiveBooking();
    const { data, error, isFetching } = useGetInspections(booking?.year);

    if (error || !booking) return <HousekeepingError className={className} />;
    if (isFetching) return <HousekeepingLoader className={className} />;
    if (!data) return <NoUpcomingHousekeeping className={className} />;

    const inspectionState = getInspectionStates(data);

    switch (inspectionState) {
        case InspectionState.UPCOMING:
            return (
                <UpcomingHousekeeping
                    className={className}
                    inspection={data}
                    academicYear={booking.year}
                />
            );

        case InspectionState.REQUESTED:
            return (
                <RequestedHousekeeping
                    className={className}
                    inspection={data}
                    academicYear={booking.year}
                />
            );
        case InspectionState.SKIPPED:
            return (
                <SkippedHousekeeping
                    className={className}
                    inspection={data}
                    academicYear={booking.year}
                />
            );
        case InspectionState.CANCELLED:
            return (
                <CancelledHousekeeping
                    className={className}
                    inspection={data}
                    academicYear={booking.year}
                />
            );
        case InspectionState.CONFIRMED:
            return (
                <ConfirmedHousekeeping
                    className={className}
                    inspection={data}
                    academicYear={booking.year}
                />
            );
        default:
            return null;
    }
};
